import classNames from "classnames";
import toString from "lodash/toString";
import { useFiltersV2Actions, useFiltersV2Store } from "PFApp/components/filters_v2";
import { SearchConfig } from "PFApp/components/search_autocomplete/search_autocomplete.types";
import { SearchInput, SearchInputProps } from "PFApp/components/search_input";
import { KnownFiltersV2 } from "PFTypes/filters_v2";
import { RecentSearchesPageKey } from "PFTypes/recent_searches";

import css from "./filters_v2_term_search.module.scss";

type FiltersV2TermSearchProps = {
  pageKey: RecentSearchesPageKey;
  autocompleteConfig?: SearchConfig;
  disabled?: boolean;
  qaId?: string;
  includeRecentSearches?: boolean;
} & ({ wide?: boolean; narrow?: never } | { wide?: never; narrow?: boolean }) &
  Omit<SearchInputProps, "term" | "onTermChange">;

export const FiltersV2TermSearch = ({
  disabled,
  narrow,
  wide,
  ...searchInputProps
}: FiltersV2TermSearchProps) => {
  const termFilter = useFiltersV2Store((state) => state.mainFilters[KnownFiltersV2.Term]);
  const { updateFilter } = useFiltersV2Actions();

  return (
    <SearchInput
      term={toString(termFilter?.value) || ""}
      onTermChange={(value: string) => {
        updateFilter({ name: KnownFiltersV2.Term, value });
      }}
      disabled={!termFilter || disabled}
      classes={{
        root: classNames(narrow && css.narrow)
      }}
      fullWidth={wide}
      {...searchInputProps}
    />
  );
};
